import React from 'react';
const Heading= (props)=>{
    return <div style={{fontSize:24, color:'#ccc', backgroundColor:'', borderBottom:'2px #ccc dashed', borderRadius:5, padding:5, fontWeight:600, marginBottom:10}}>{props.text}</div>
}
export default Heading;